import { cva } from "class-variance-authority"

export const textSizeCva = cva([], {
	variants: {
		size: {
			xs: ["text-xs"],
			sm: ["text-sm"],
			md: ["text-base"],
			lg: ["text-lg"],
			xl: ["text-xl"],
		},
	},
})
